/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ExportMcpMetadataRequestBody = {
  /**
   * The ID of a toolset-backed MCP server. Mutually exclusive with mcp_slug.
   */
  mcpServerId?: string | undefined;
  /**
   * The MCP server slug (from the install URL). Mutually exclusive with mcp_server_id.
   */
  mcpSlug?: string | undefined;
};

/** @internal */
export type ExportMcpMetadataRequestBody$Outbound = {
  mcp_server_id?: string | undefined;
  mcp_slug?: string | undefined;
};

/** @internal */
export const ExportMcpMetadataRequestBody$outboundSchema: z.ZodMiniType<
  ExportMcpMetadataRequestBody$Outbound,
  ExportMcpMetadataRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.optional(z.string()),
    mcpSlug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      mcpSlug: "mcp_slug",
    });
  }),
);

export function exportMcpMetadataRequestBodyToJSON(
  exportMcpMetadataRequestBody: ExportMcpMetadataRequestBody,
): string {
  return JSON.stringify(
    ExportMcpMetadataRequestBody$outboundSchema.parse(
      exportMcpMetadataRequestBody,
    ),
  );
}
